import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Helper} from '../../../../helpers/helper.service';
import {TranslateService} from '@ngx-translate/core';
import {WorkFormItemService} from '../../../Services/work-form-item.service';
import {WorkFormItem} from '../../../Models/WorkFormItem';

@Component({
  selector: 'app-manage-dealer-points',
  templateUrl: './manage-work-form-item.component.html',
  styleUrls: ['./manage-work-form-item.component.scss']
})
export class ManageWorkFormItemComponent implements OnInit {
  public modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
      ['blockquote', 'code-block'],

      [{'header': 1}, {'header': 2}],               // custom button values
      [{'list': 'ordered'}, {'list': 'bullet'}],
      [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
      [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
      [{'direction': 'rtl'}],                         // text direction

      [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
      [{'header': [1, 2, 3, 4, 5, 6, false]}],

      [{'color': []}, {'background': []}],          // dropdown with defaults from theme
      [{'font': []}],
      [{'align': []}],

      ['clean'],                                         // remove formatting button

      ['link']                         // link and image, video
    ]
  };

  public workFormItem = new WorkFormItem();
  public isEdit = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private workFormItemService: WorkFormItemService,
    private helper: Helper,
    private translate: TranslateService
  ) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (Helper.isDefined(params['id'])) {
        this.isEdit = true;
        this.workFormItemService.showWorkFormItem(params['id']).subscribe(res => {
          this.workFormItem = res;
        });
      }
    });
  }

  backToOverview() {
    this.router.navigateByUrl('/back-office/work-form-item/overview');
  }

  updateWorkFormItem() {
    const id = this.workFormItem.id;
    delete this.workFormItem.id;
    this.workFormItemService.updateWorkFormItem(this.workFormItem, id).subscribe( res => {
      this.helper.popMessageDialog(
        this.translate.instant('global.success_message.title'),
        this.translate.instant('global.success_message.description'),
        'success',
        false
      );
    });
  }

  createWorkFormItem() {
    this.workFormItemService.createWorkFormItem(this.workFormItem).subscribe( res => {
      this.helper.popMessageDialog(
        this.translate.instant('global.success_message.title'),
        this.translate.instant('global.success_message.description'),
        'success',
        false
      );
    });
  }

  saveWorkFormItem() {
    if (this.workFormItem.id) {
      this.updateWorkFormItem();
    } else {
      this.createWorkFormItem();
    }
    this.router.navigateByUrl('/back-office/work-form-item/overview');
  }
}
